// Author LFT
// Date 2020-12-22 10:58:56

import * as model from "@/model/sithMes/mst/SithMesReportTemplateRoleModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesReportTemplateRole(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    .buildStore()
